import { render, staticRenderFns } from "./xuankuaYcList.vue?vue&type=template&id=55bd62b5&scoped=true"
import script from "./xuankuaYcList.vue?vue&type=script&lang=js"
export * from "./xuankuaYcList.vue?vue&type=script&lang=js"
import style0 from "./xuankuaYcList.vue?vue&type=style&index=0&id=55bd62b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd62b5",
  null
  
)

export default component.exports